import { get } from "lodash";
import styled from "styled-components/macro";

export const SummaryItemsContainer = styled.div`
    ${({ theme }) => theme.bp.xs`
        height: auto;
        max-width: calc(100% - 22px);
    `};
    ${({ theme }) => theme.bp.sm`
        align-self: flex-start;
        width: 80%;
    `};
    position: relative;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    margin: 5px 5vw 20px 5vw;
`;

export const SummaryItems = styled.div`
    ${({ theme }) => theme.bp.xs`
        margin: 0px 10px;
        max-width: 100%;
        flex-flow: column;
    `};
    ${({ theme }) => theme.bp.tb`
        flex-flow: row nowrap;
    `};
    height: auto;
    min-width: 100%;
    flex: 0 1 auto;
    margin-left: auto;
    display: flex;
    justify-content: space-between;
`;

export const SummaryDisclaimer = styled.div`
    height: auto;
    align-self: center;
    font-size: ${props => props.theme.summary.disclaimer.fontSize};
    max-width: 80%;
    color: ${props => props.theme.textColor};
    font-family: ${props => props.theme.fontFamily};
    font-weight: ${props => props.theme.summary.disclaimer.fontWeight};
    padding-top: ${props => props.theme.summary.disclaimer.paddingTop};
    ${({ theme }) =>
        theme.bp.xxxl`
            font-size: 1em;
        `}
`;

export const SummaryInfo = styled.div`
    ${({ theme }) => theme.bp.xs`
        flex-flow: column nowrap;
    `};
    ${({ theme }) => theme.bp.tb`
        padding: 20px;            
        overflow-x: auto;
        flex-flow: row nowrap;
    `};
    width: 100%;
    display: flex;
`;
export const SummaryInfoItem = styled.div<SummaryInfoItemProps>`
    ${({ theme, fullscreen }) =>
        fullscreen ? theme.bp.xs`padding: 15px 24px 15px 20px;` : theme.bp.xs`padding: 0px 10px;`};
    ${({ theme, fullscreen }) =>
        fullscreen ? theme.bp.xxl`padding: 20px 30px 20px 20px;` : theme.bp.xxl`padding-right: 70px;`};

    display: flex;
    flex-flow: column wrap;
    justify-content: flex-start;
`;

interface SummaryInfoItemProps {
    fullscreen?: boolean | null;
}

export const SummaryInfoItemMenu = styled.div`
    ${({ theme }) => theme.bp.xs`
        font-size: 14px;
        font-weight: bold;
    `};
    ${({ theme }) => theme.bp.tb`
        font-size: 18px;
        font-weight: normal;
    `};
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1.3em;
                `}
    padding-bottom: 8px;
    color: ${props => props.theme.textColor};
    font-family: ${props => props.theme.fontFamily};
`;
export const SummaryInfoItemContainer = styled.div`
    ${({ theme }) => theme.bp.xs`
        font-size: 13px;
    `};
    ${({ theme }) => theme.bp.xl`
        font-size: 15px;
    `};
    ${({ theme }) =>
        theme.bp.xxxl`
        font-size: 1.2em;
    `}
    padding: 0;
    color: ${props => props.theme.textColor};
    font-family: ${props => props.theme.fontFamily};
    font-weight: 200;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
`;

export const SummaryInfoItemName = styled.p`
    ${({ theme }) => theme.bp.xs`
        font-size: 13px;
    `};
    ${({ theme }) => theme.bp.xl`
        font-size: 15px;
    `};
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1em;
                `}
    flex: 8;
    width: 80%;
    margin: 0;
    padding: 3px 0;
    color: ${props => props.theme.textColor};
`;

export const SummaryInfoItemPrice = styled.span`
    min-width: 100px;
    margin: 0;
    padding: 3px 0;
    text-align: right;
`;

export const ConfigurationImage = styled.img<ConfigurationImageProps>`
    max-width: 100%;
    max-height: ${props => (props.fullscreen ? "100vh" : "60vh")};
    ${props => (props.fullscreen ? "width:100%;" : "")}
    object-fit: contain;
    border-radius: 5px;
`;

export const FullscreenSummaryItems = styled.div`
    padding: 20px 5px 20px 20px;
    border-inline: 1px solid #d9d9d9;
    display: flex;
    width: inherit;
    justify-content: flex-start;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 20%);
    flex-direction: column;
    margin-top: 30px;
`;

export const SummaryTotalPrice = styled.div`
    ${({ theme }) => theme.bp.xs`
        font-size: 30px;
        padding: 5px 10px;
        font-weight: bold;
    `};
    ${({ theme }) => theme.bp.tb`
        padding: 20px;
        font-weight: regular;
    `};
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 2em;
                `}
    text-align: center;
    color: ${props => props.theme.textColor};
    font-family: ${props => props.theme.fontFamily};
    flex: 1 0 auto;
    margin: 25px;
`;

export const ToggleSummaryItemsButton = styled.div`
    ${({ theme }) => theme.bp.xs`
        font-size: 13px;
        margin: 5px auto;
        height: 40px;
    `};
    ${({ theme }) => theme.bp.sm`
        font-size: 14px;
        margin: 20px auto 0px auto;
    `};
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1em;
                `}
    user-select: none;
    background: #fff;
    color: ${({ theme }) => get(theme, "summary.toggleSummaryItemsButton.color")};
    border: 1px solid ${({ theme }) => get(theme, "summary.toggleSummaryItemsButton.borderColor")};
    cursor: pointer;
    width: 200px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background 0.2s ease-in-out;

    @media (hover) {
        &:hover {
            background: ${({ theme }) => get(theme, "summary.toggleSummaryItemsButton.hoverColor")};
        }
        &:active {
            background: ${({ theme }) => get(theme, "summary.toggleSummaryItemsButton.activeColor")};
        }
    }
`;

export const RoomSurfaces = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    img {
        max-width: 200px;
    }
`;

export const ToggleRoomSurfacesContainer = styled.div`
    width: 96%;
    padding-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`;

interface ConfigurationImageProps {
    fullscreen: boolean;
}
